var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCounter4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_199_1999)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 50,
    r: 40,
    fill: "#30BEAD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M73.5009 58.4067L72.8431 56.9413C72.7641 56.7814 72.7641 56.5949 72.8431 56.435L73.5009 54.9696C73.7904 54.3301 73.8167 53.5841 73.5536 52.918C73.2904 52.2518 72.7378 51.719 72.0536 51.4525L70.58 50.893C70.4221 50.8397 70.2906 50.7065 70.2379 50.5466L69.6853 49.0545C69.4222 48.3618 68.8959 47.8289 68.238 47.5624C67.5802 47.2693 66.8433 47.296 66.2118 47.5891L64.7645 48.2552C64.6066 48.3351 64.4224 48.3351 64.2645 48.2552L62.8172 47.5891C62.1593 47.296 61.4225 47.2693 60.7647 47.5624C60.1068 47.8289 59.5805 48.3884 59.3437 49.0545L58.7911 50.5466C58.7121 50.7065 58.6069 50.8397 58.4227 50.893L56.9491 51.4525C56.2912 51.719 55.7386 52.2518 55.4754 52.918C55.2123 53.5841 55.2123 54.3301 55.5018 54.9962L56.1596 56.4617C56.2386 56.6215 56.2386 56.808 56.1596 56.9679L55.5018 58.4067C55.2123 59.0728 55.2123 59.8189 55.4754 60.485C55.7386 61.1511 56.2912 61.684 56.9491 61.9238L58.4227 62.4833C58.5806 62.5366 58.7121 62.6698 58.7648 62.8297L59.3174 64.3218C59.5542 64.9879 60.0805 65.5474 60.7384 65.8139C61.0541 65.9471 61.3962 66.0004 61.712 66.0004C62.0804 66.0004 62.4488 65.9205 62.7909 65.7606L64.2382 65.0945C64.3961 65.0145 64.5803 65.0145 64.7382 65.0945L66.1855 65.7606C66.8433 66.0537 67.5802 66.0803 68.238 65.7872C68.8959 65.5208 69.4222 64.9613 69.659 64.2951L70.2116 62.8031C70.2642 62.6432 70.3958 62.51 70.5537 62.4567L72.0273 61.8971C72.6852 61.6573 73.2378 61.1245 73.5009 60.4583C73.8167 59.8189 73.7904 59.0728 73.5009 58.4067ZM64.5013 61.3643C61.9488 61.3643 59.8963 59.2593 59.8963 56.7015C59.8963 54.1436 61.9751 52.0387 64.5013 52.0387C67.0276 52.0387 69.1064 54.1436 69.1064 56.7015C69.1064 59.2593 67.0539 61.3643 64.5013 61.3643Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7144 34H71.1094V45.5637L76.346 44.1249C77.9249 43.6986 79.0038 42.2331 79.0038 40.5812V36.3447C79.0038 35.0391 77.9775 34 76.7144 34Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9207 34H52.3157C51.0263 34 50 35.0391 50 36.3447V40.5812C50 42.2331 51.1052 43.6986 52.6578 44.1249L57.8944 45.5637V34H57.9207Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1299 46.0167V34H59.8935V46.0167C59.8935 46.0433 59.8672 46.0699 59.8672 46.0966L64.2354 47.3222C64.3144 47.3489 64.4196 47.3489 64.4986 47.3489C64.5775 47.3489 64.6828 47.3489 64.7617 47.3222L69.1299 46.1232C69.1299 46.0699 69.1299 46.0433 69.1299 46.0167Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_199_1999",
    x: 0,
    y: 0,
    width: 130,
    height: 130,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.72549 0 0 0 0 0.701961 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_199_1999"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_199_1999",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounter4);
export default __webpack_public_path__ + "static/media/counter-4.c916c5d056d80d2fd1c904a5a12e67b2.svg";
export { ForwardRef as ReactComponent };